var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStressLevelYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.653,
    height: 24.884,
    viewBox: "0 0 17.653 24.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15096",
    "data-name": "Group 15096",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15095",
    "data-name": "Group 15095",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41112",
    "data-name": "Path 41112",
    d: "M277.489,72.234l.383-2.032h-1.853l1.3-3.181h1.7L277.986,68.9h2.152Z",
    transform: "translate(-267.886 -67.021)",
    fill: "#f5d730"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41113",
    "data-name": "Path 41113",
    d: "M283.93,75.251l.811-1.016-1.03-.545,1.661-1.384.945.5-1.128.736,1.2.633Z",
    transform: "translate(-270.106 -68.546)",
    fill: "#f5d730"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41114",
    "data-name": "Path 41114",
    d: "M269.344,74.659l-.7-1.1-.851.8-.767-2.021.781-.73.328,1.306.989-.924Z",
    transform: "translate(-265.292 -68.344)",
    fill: "#f5d730"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41115",
    "data-name": "Path 41115",
    d: "M264.587,98.86H282.24c.006-.07-.43-3.464-.526-3.79a1.987,1.987,0,0,0-.61-1.212c-.2-.145-2.865-1.673-3.993-2.324-.238-.137-.486-.257-.783-.413-.077.079-.15.155-.226.229a3.63,3.63,0,0,1-3.194,1.155,3.113,3.113,0,0,1-.96-.275,12,12,0,0,1-1.58-1.063c-.2.081-4.236,2.432-4.856,2.779a.383.383,0,0,0-.166.243C265.288,94.544,264.584,98.59,264.587,98.86Z",
    transform: "translate(-264.587 -73.977)",
    fill: "#f5d730"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41116",
    "data-name": "Path 41116",
    d: "M279.46,79.953a1.231,1.231,0,0,0,.152.177,1.52,1.52,0,0,1,.071,1.436c-.17.539-.51,1-.642,1.548a.493.493,0,0,1-.117.264,1.138,1.138,0,0,1-.2.11.8.8,0,0,0-.268.355c-.664,1.318-1.84,2.839-3.469,2.813-1.5-.023-2.572-1.405-3.256-2.593a4.094,4.094,0,0,0-.255-.469c-.09-.117-.252-.154-.342-.274a.589.589,0,0,1-.081-.179,12.594,12.594,0,0,0-.5-1.263,2.954,2.954,0,0,1-.265-1.269.478.478,0,0,1,.161-.447.39.39,0,0,0,.09-.272A11.494,11.494,0,0,1,270.6,78.4a4.365,4.365,0,0,1,.506-1.564,3.449,3.449,0,0,1,1.017-1.081,4.448,4.448,0,0,1,1.633-.621,3.315,3.315,0,0,1,1.929.181,10.135,10.135,0,0,0,1.771.334,2.79,2.79,0,0,1,1.874,2.133,5.871,5.871,0,0,1,.086,1.8.66.66,0,0,0,.037.357Z",
    transform: "translate(-266.231 -69.345)",
    fill: "#f5d730"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressLevelYellow);
export default __webpack_public_path__ + "static/media/stress-level-yellow.d62165b38d1e36987e37cc71cb07b200.svg";
export { ForwardRef as ReactComponent };